import firebase from 'firebase';

export default {

    data () {
        return {
          env: process.env,
          location: location,
          currentUser: null,
          currentUserClaims: null,
          CLAIMS: ['a']
        }
    },

    methods: {

        loadClaims(user) {
            var claims = {}
            for(var i in this.CLAIMS) { claims[this.CLAIMS[i]] = 0 }
            this.currentUserClaims = claims
            if(user) {
                user.getIdTokenResult().then((tokenRes) => {
                    if('claims' in tokenRes) {
                        for(var i in this.CLAIMS) {
                            claims[this.CLAIMS[i]] = 
                                (this.CLAIMS[i] in tokenRes.claims && tokenRes.claims[this.CLAIMS[i]] === 1)
                                ? 1 : 0
                        }
                        this.$set(this, 'currentUserClaims', claims)
                    }
                })
            }
        },

        hasCurrentUserClaims(claims) {
            for(var i in claims) {
                if(claims[i] in this.currentUserClaims && this.currentUserClaims[claims[i]] === 1) {
                    return true
                }
            }
            return false;
        },

        generateEmailLink(email, to, data) {
            return 'mailto:' + to 
                + '?subject=' + this.$t('emails.' + email + '.subject', data)
                + '&body=' + this.$t('emails.' + email + '.body', data)
        }

    },

    created() {
        this.loadClaims(null)
        firebase.auth().onAuthStateChanged((user) => {
            this.currentUser = user ? user : null;
            this.loadClaims(user)
            if(!user) {
                this.$globalData.sites = null
                this.currentUserClaims = null
            }
        })
    }

};


// WEBPACK FOOTER //
// ./src/mixins/SkVars.js